<template>
  <div id="sidenavbar" class="container z-depth-1 pb-4">
    <div class="sidenavheader">
      <h6 class="title white-text my-0 py-0">
        lyst<span style="color: rgb(208, 179, 255);">it</span>
      </h6>
      <h5 class="logo-text white-text my-0 py-0">Cr Ads Manager</h5>
    </div>

    <div class="container">
      <ul class="collapsible mt-3 grey lighten-4">
        <li class="active">
          <div @click="first = !first" class="collapsible-header">
            <i class="material-icons">fingerprint</i>
            <!-- synk -->
            Cr credentials
          </div>
          <div v-if="first" class="white">
            <dy-login></dy-login>
          </div>
        </li>
        <li>
          <div @click="second = !second" class="collapsible-header">
            <i class="material-icons">play_circle_outline</i>
            Repost ads
          </div>
          <div v-if="second" class="m-4">
            <span>Select ads from the table that needs to be reposted</span>
            <hr />
            <a @click="closeSecond" class="waves-effect waves-light btn mt-2">
              <span>Repost</span>
            </a>
          </div>
        </li>
        <li>
          <div @click="third = !third" class="collapsible-header">
            <i class="material-icons">subject</i>
            Report
          </div>
          <div v-if="third" class="report m-4 pb-4 grey lighten-4">
            <!-- <span>Reposted 12 ads. 1 removed add must be updated manually</span> -->
            <div class="container">
              <dy-small-preloader></dy-small-preloader>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Login from "./Login.vue";
import SmallPreloader from "./SmallPreloader.vue";

export default {
  data() {
    return { first: true, second: false, third: false };
  },
  components: {
    dyLogin: Login,
    dySmallPreloader: SmallPreloader
  },
  methods: {
    loadAds() {
      console.log("called from nav bar");
      this.$parent.loadAds();
    },
    closeFirst() {
      this.first = false;
      this.second = true;
      this.third = false;
    },
    closeSecond() {
      this.first = false;
      this.second = false;
      this.third = true;
    }
  }
};
</script>

<style scoped>
.title {
  font-size: 5.7em;
  font-family: "Nunito", sans-serif;
}
#sidenavbar {
  height: 100%;
  width: 25%;
  min-width: 200px;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  overflow-x: hidden;
  padding: 0px;
  background-color: rgb(208, 179, 255);
}
.sidenavheader {
  padding: 1em 1em 1em;
  height: 23%;
  background-color: rgb(62, 0, 161);
}
.sidenavbody {
  padding: 1em;
  height: 80%;
  background-color: rgb(208, 179, 255);
}
.report {
  height: 25em;
}
.logo-text {
  font-family: "Open Sans", sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue